// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"6cd7c94c","144":"114ca59e","193":"afbbded2","237":"e733e823","546":"8ff8fa74","630":"0df47580","742":"7dd3f592","806":"73a8b367"}[chunkId] + ".chunk.css";
};